import * as React from 'react';

const textColorFor = color => {
    const match = /^#([0-9a-f]{6})$/i.exec(color ?? "");
    if (!match) return "#fff";

    const value = parseInt(match[1], 16);
    const red = (value >> 16) & 255;
    const green = (value >> 8) & 255;
    const blue = value & 255;
    const luminance = (red * 299 + green * 587 + blue * 114) / 1000;
    return luminance > 150 ? "#212529" : "#fff";
};

export const PicklistColorBadge = React.memo(({ text, color }) => {
    if (!text) return null;

    const backgroundColor = color || "#6c757d";

    return (
        <span
            className="badge rounded-pill"
            style={{
                backgroundColor,
                border: `1px solid ${backgroundColor}`,
                color: textColorFor(backgroundColor),
                fontSize: "0.78em",
                fontWeight: 600
            }}
        >
            {text}
        </span>
    );
});
